import { ArticleCategoryItem } from './article-category-item';

export class ArticleTableContent {
  [key: string]: ArticleCategoryItem;
}
